import React from 'react';
import Spinner from 'src/view/shared/Spinner';
import ServicioFormPage from '../form/ServicioFormPage';

function ServicioView(props) {
  const renderView = () => {
    const {record, drawer} = props;
    return <ServicioFormPage record={record} disabled={true} drawer={drawer} />;
  };

  const {record, loading} = props;

  if (loading || !record) {
    return <Spinner />;
  }

  return renderView();
}

export default ServicioView;
